// 导出状态
export let exportStates = [
  {
    label: '导出中',
    value: 'CREATED'
  },
  {
    label: '已导出',
    value: 'STORED'
  },
  {
    label: '导出失败',
    value: 'FAILED'
  }
]
// 下载状态
export let downloadStates = [
  {
    label: '下载中',
    value: 'CREATED'
  },
  {
    label: '已下载',
    value: 'STORED'
  },
  {
    label: '下载失败',
    value: 'FAILED'
  }
]
// 导入状态
export let importStates = [
  {
    label: '处理中',
    value: 'PROCESSING'
  },
  {
    label: '处理异常',
    value: 'UNKNOWN'
  },
  {
    label: '失败',
    value: 'FAILED'
  },
  {
    label: '处理成功',
    value: 'COMPLETED'
  },
]
// 报告签章类型
export let signatureType = [
  {
    label: '自营报告签章',
    value: 'CREATED'
  },
  {
    label: '客户报告签章',
    value: 'STORED'
  },
  {
    label: '无报告签章',
    value: 'FAILED'
  }
]
// 受检人年龄单位类型
export let ageType = [
  {
    label: '岁',
    value: 'YEAR'
  },
  {
    label: '月',
    value: 'MONTH'
  },
  {
    label: '天',
    value: 'DAY'
  }
]
